/* @flow */

import * as React from 'react';
import {useDispatch} from 'react-redux';

import {Button} from 'shells/button';
import {AccountIcon} from 'shells/icon';
import {Popover} from 'shells/popover';
import {appHistory} from '../../../../../history';
import {addNotification} from '../../../../../notifications/index';

import {useCreateAccountFromMcfxCompany} from '../../graphql/hooks/use-create-account-from-mcfx-company';
import * as actions from '../../companies-list/companies-actions';
import {AddCompanyPopover} from './add-company-popover';

type Props = {
    companyId: string,
    companyName: string,
    onCloseSidebar: () => void,
};

export function ConvertCompanyButton(props: Props) {
    const [shouldShowPopover, setShouldShowPopover] = React.useState<boolean>(false);
    const [errorMessage, setErrorMessage] = React.useState<?string>(null);

    const dispatch = useDispatch();

    const addCompanyButtonRef = React.useRef();
    const onCloseModal = () => setShouldShowPopover(false);

    const createCompany = useCreateAccountFromMcfxCompany();
    const onCreateCompany = (createRelatedLead: boolean, stagesetId: ?string) =>
        createCompany({mcfxCompanyId: props.companyId, createRelatedLead, stagesetId})
            .then((response) => {
                const updatedCompany =
                    response &&
                    response.data &&
                    response.data.createAccountFromMcfxCompany &&
                    response.data.createAccountFromMcfxCompany.mcfxCompany;

                if (updatedCompany) {
                    dispatch(
                        actions.updateMcfxCompaniesListItems({updatedCompanies: [updatedCompany]})
                    );

                    const relatedAccountPath =
                        updatedCompany.relatedAccount && updatedCompany.relatedAccount.htmlUrlPath;

                    if (relatedAccountPath)
                        addNotification('Added new company', {
                            body: updatedCompany.name,
                            icon: 'check',
                            onClick: () => {
                                appHistory.push(relatedAccountPath);
                                props.onCloseSidebar();
                            },
                        });
                }
            })
            .catch(() => setErrorMessage('Oops! Something went wrong'));

    return (
        <>
            {/* $FlowIgnore - the AccountIcon props are different from other icons */}
            <Button
                variant='save'
                size='big'
                isFullWidth={true}
                icon={AccountIcon}
                onClick={() => setShouldShowPopover(true)}
                getButtonRef={addCompanyButtonRef}
            >
                Add <strong>{props.companyName}</strong> to Nutshell
            </Button>

            {shouldShowPopover && addCompanyButtonRef && addCompanyButtonRef.current ? (
                <AddCompanyPopover
                    anchor={addCompanyButtonRef.current}
                    name={props.companyName}
                    onClose={onCloseModal}
                    onCreate={onCreateCompany}
                />
            ) : (
                undefined
            )}
            {errorMessage && addCompanyButtonRef && addCompanyButtonRef.current ? (
                <Popover
                    anchor={addCompanyButtonRef.current}
                    isDialog={true}
                    onBlur={() => {
                        setErrorMessage(null);
                    }}
                    bodyColor='error'
                >
                    {errorMessage}
                </Popover>
            ) : (
                undefined
            )}
        </>
    );
}
